import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import { FormControl, FormLabel, Grid, IconButton, Slider, TextField } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';
import { Add, Remove } from '@mui/icons-material';

const DuracionMiniTest = () => {
  const { promptData, setPromptData } = useActividadesContext();
  const [duracion, setDuracion] = useState(promptData.cantidad_tiempo || 5);

  useEffect(() => {
    setPromptData((prevData) => ({
      ...prevData,
      cantidad_tiempo: duracion,
    }));
  }, [duracion, setPromptData]);

  const handleSliderChange = (event, newValue) => {
    setDuracion(newValue);
  };

  const handleInputChange = (event) => {
    const newValue = event.target.value === '' ? '' : Number(event.target.value);
    setDuracion(newValue);
  };

  const handleIncrement = () => {
    setDuracion((prev) => Math.min(prev + 5, 90));
  };

  const handleDecrement = () => {
    setDuracion((prev) => Math.max(prev - 5, 5));
  };

  return (
    <Grid sx={{ mb: 3 }}>
      <FormControl component="fieldset">
        <Typography 
          sx={{ 
            fontFamily: 'montserrat', 
            fontSize: '1.25rem', 
            fontWeight: 'bold', 
            color: '#336B87' 
          }}
        >
          Tiempo de duración *
        </Typography>
        <FormLabel 
          component="p" 
          sx={{ fontFamily: 'montserrat', fontSize: '0.85rem', mt: 0.2 }}
        >
          Seleccione el tiempo de duración de la prueba en minutos.
        </FormLabel>
        <Grid container alignItems="center" justifyContent="space-between" spacing={2} width={600}>
          {/* Slider en la parte izquierda */}
          <Grid item xs={8}>
            <Slider
              value={typeof duracion === 'number' ? duracion : 0}
              onChange={handleSliderChange}
              step={5}
              min={5}
              max={90}
              valueLabelDisplay="auto"
              valueLabelFormat={(value) => `${value} minutos`}
              aria-labelledby="tiempo-duracion-slider"
              sx={{
                color: '#336B87',
                '& .MuiSlider-markLabel': {
                  color: '#336B87',
                  fontFamily: 'montserrat',
                },
                '& .MuiSlider-valueLabel': {
                  backgroundColor: '#F9DA96',
                  color: '#209099',
                  fontFamily: 'montserrat',
                },
              }}
            />
          </Grid>
          <Grid item xs={4} container spacing={1}>
            <Grid item>
              <IconButton onClick={handleDecrement} disabled={duracion <= 5}>
                <Remove />
              </IconButton>
            </Grid>
            <Grid item>
              <TextField
                variant="standard"
                type="number"
                value={duracion}
                onChange={handleInputChange}
                inputProps={{
                  step: 5,
                  min: 5,
                  max: 90,
                  style: { fontFamily: 'montserrat', color: '#336B87', textAlign: 'center' },
                }}
                sx={{ width: 40, textAlign: 'center', fontFamily: 'montserrat', color: '#336B87' }}
              />
            </Grid>
            <Grid item>
              <IconButton onClick={handleIncrement} disabled={duracion >= 90}>
                <Add />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </FormControl>
    </Grid>
  );
};

export default DuracionMiniTest;
